import React, {useEffect, useRef, useState} from "react";
import history from "../../utils/History";
import Input from "../inputText/Input";
import CheckBox from "../checkBox/CheckBox";
import RadioButton from "../radioButton/RadioButton";
import Calendar from "../calendar/Calendar";
import Utils from "../../utils/Utils";
import style from "./Table.module.css"
import Icon from "../icon/Icon";
import arrow_sort_both from "../../img/icons/arrowupdown.PNG"
import {Row} from 'react-bootstrap';
import Button from "../Button/Button";
import iconaTelefonoBianco from "../../img/icons/iconaTelefonoBianco.PNG";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import Spinner from "../spinner/Spinner";

function Table(props) {

    const province = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [cols, setCols] = useState([])
    const [rows, setRows] = useState([])
    const [sort, setSort] = useState({colName: "", typeSort: ""})
    const [showSpinner,setShowSpinner] = useState(false)
    const isPageWide = MediaQueryUtils('(min-width: 950px)')
    const prevRowsRef = useRef();
    const prevRows = prevRowsRef.current;
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    const iconSalvaCsv = (
        <svg fill={"#1b7ea9"} width="24" height="24" viewBox="0 0 24 24" id="it-download"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 14.2L7.7 9.9l.7-.7 3.1 3.1V3h1v9.2l3.1-3 .7.7zm7-2.2v7.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V12H4v7.5A1.5 1.5 0 005.5 21h13a1.5 1.5 0 001.5-1.5V12z"/>
            <path fill="none" d="M0 0h24v24H0z"/>
        </svg>)
    const iconAnteprima = (
        <svg fill={"#1b7ea9"} width="24" height="24" viewBox="0 0 24 24" id="it-print"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21 9.5A1.5 1.5 0 0019.5 8H17V3H7v5H4.5A1.5 1.5 0 003 9.5V16h2v3h2v2h10v-2h2v-3h2zM8 4h8v4H8zM6 18v-4h1v4zm10 2H8v-6h8v6zm2-2h-1v-4h1v4zm2-3h-1v-2H5v2H4V9.5a.5.5 0 01.5-.5h15a.5.5 0 01.5.5zM6 11h4v1H6z"/>
            <path fill="none" d="M0 0h24v24H0z"/>
        </svg>)

    const arrowDownSvg = (
        <svg width={"34"} height={"34"} fill={"#1b7ea9"} viewBox="0 0 24 24"
             id="it-arrow-down-triangle" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
            <path fill="none" d="M0 0h24v24H0z"/>
        </svg>)

    const arrowUpSvg = (
        <svg width={"34"} height={"34"} fill={"#1b7ea9"} viewBox="0 0 24 24" id="it-arrow-up-triangle"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M14.8 12H9.2a1 1 0 01-.7-1.7L12 6.8l3.5 3.5a1 1 0 01-.7 1.7z"/>
            <path fill="none" d="M0 0h24v24H0z"/>
        </svg>)


    useEffect(() => {
        prevRowsRef.current = props.rows;
    });

    useEffect(() => {
        createTable()
    }, [props.cols, Utils.AreObjectsEquals(props.rows, prevRows), sort])

    function createTable() {
        createCols()
        createRows()
    }

    function onClickSort(colName, typeSort) {
        setSort({colName: colName, typeSort: typeSort})
    }

    function onClickButtonAntemprima(){
        props.onClickAnteprima()
    }

    function onClickButtonSalvaCsv(){
        props.onClickSalvaCsv()
    }

    function createCols() {
        let newCols = []
        props.cols.forEach(col => {
            newCols.push(
                <th key={col.key} className={style.azTableHeaderCellMinWidth.concat(' noselect')} scope="col" style={props.customStyleTh}>
                    <div className={"row"} style={{justifyContent: "center", alignItems: "center"}}>
                        <div className={"col-9 ".concat(style.tooltipTable)} style={{textAlign: "center"}}>
                            <span data-toggle="tooltip" data-placement="top"
                                  title={col.name}>{col.name}</span>
                        </div>
                        <div className={"col-1"}>
                            {col.typeSort ? col.name !== sort.colName ?
                                <span onClick={() => {
                                    onClickSort(col.name, "DESC")
                                    if(props.setSort)props.setSort(col.key,"DESC")
                                }}>
                            <Icon path={arrow_sort_both}/>
                        </span> :
                                sort.typeSort === "ASC" ?
                                    <span onClick={() => {
                                        onClickSort(col.name, "DESC")
                                        if(props.setSort)props.setSort(col.key,"DESC")
                                    }}>
                                    {arrowUpSvg}
                        </span> :
                                    sort.typeSort === "DESC" ?
                                        <span onClick={() => {
                                            onClickSort(col.name, "ASC")
                                            if(props.setSort)props.setSort(col.key,"ASC")
                                        }}>
                                        {arrowDownSvg}
                        </span> :
                                        <span onClick={() => {
                                            onClickSort(col.name, "ASC")
                                            if(props.setSort)props.setSort(col.key,"ASC")
                                        }}>
                            <Icon path={arrow_sort_both} className={style.arrowBothSortStyle}/>
                        </span>
                            : null}
                        </div>
                    </div>
                </th>
            );
        })
        setCols(newCols);
    }

    function getActualSort() {
        let actualSorted

        props.cols.forEach(col => {
            if (col.typeSort && col.typeSort !== "none") {
                actualSorted = {col: col.key, direction: col.typeSort};
            }
        });

        return actualSorted;
    }

    function changePaginationSize(event){

        if (props.changePaginationSize) {
            props.changePaginationSize(
                getActualSort() ? getActualSort().col : null,
                getActualSort() ? getActualSort().direction : null,
                0,
                event.target.value
            )
        }

    };

    function createPageLengthSelect() {
        return (
            <>
                {props.sizeElementView ? (
                    <div className="dataTables_length bs-select noPrint">
                        <span style={{fontSize: "16px"}}>
                            <label>Mostra&nbsp;</label>
                            <select name="test_length"
                                    defaultValue={props.size ? props.size : "10"}
                                    onChange={(event) => changePaginationSize(event)}>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>{" "}
                            risultati
            </span>
                    </div>
                ) : null}
            </>
        );
    }

    function createRows() {
        let newRow = []
        let finalRows = []
        let colElement
        props.rows.forEach((row, i) => {
            newRow = []

            props.cols.forEach(col => {
                switch (col.type) {
                    case "input": {
                        colElement =
                            (<Input
                                    placeholder={col.placeholder}
                                    id={col.key + i}
                                    value={row[col.key] === null ? "" : row[col.key]}
                                    onChange={(event) => {
                                        col.onChangeCol(event.target.id, event.target.value, i)
                                    }
                                    }
                                    disabled={col.disabled}
                                    errorClause={col.errorClause}
                                    errorMessage={col.errorMessage}
                                />
                            )
                        break;
                    }
                    case "link": {
                        colElement =
                            (
                                <a onClick={() => history.push(col.pathname + row[col.key])}
                                   style={{cursor: "pointer"}}>
                                        <span id={col.key + i} style={{
                                            color: "#1b7ea9",
                                            textDecoration: "underline"
                                        }}>{col.span ? col.span : row[col.key]} </span>
                                </a>
                            )
                        break;
                    }
                    case "checkBox": {
                        colElement =
                            (
                                <CheckBox
                                    id={col.key + i}
                                    onChange={(event) => col.onChangeCol(event.target.id, event.target.checked, i)}
                                    checked={row[col.key]}
                                    text={"Prova Testo"}
                                    disabled={col.disabled}
                                />
                            )
                        break;
                    }
                    case "radioButton": {
                        colElement =
                            (
                                <RadioButton
                                    id={col.key + i}
                                    onChange={(event) => col.onChangeCol(event.target.id, event.target.checked, i)}
                                    checked={row[col.key]}
                                    text={"Prova Testo"}
                                    disabled={col.disabled}
                                />
                            )
                        break;
                    }
                    case "calendar": {
                        colElement =
                            (
                                <Calendar
                                    id={col.key + i}
                                    value={row[col.key] === null ? "" : row[col.key]}
                                    index={i}
                                    onChange={col.onChangeCol}
                                    disabled={col.disabled}
                                    errorClause={col.errorClause}
                                    errorMessage={col.errorMessage}
                                />
                            )
                        break;
                    }
                    case "modal": {
                        colElement =
                            (
                                <Button
                                    id={col.key + i}
                                    typeButton={col.typeButton}
                                    className={col.className}
                                    style={col.style}
                                    text={col.text}
                                    dataTarget={col.dataTarget + i}
                                    dataToggle={col.dataToggle}
                                    body={col.modalBody}
                                    header={col.header}
                                    onClick={() => col.onClick(row[col.key])}
                                    dataBackdrop={"static"} dataKeyboard={false}
                                />
                            )
                        break;
                    }
                    case "button": {
                        if(col.check === "checkSportello" && (sessioneUtente?.ruolo?.toUpperCase() === "RAF-RDS" && parseInt(sessioneUtente?.sportello?.codiceSportello) !== row.id)){
                            colElement = <></>
                        }else if(col.check === "checkUtente" && (sessioneUtente?.ruolo?.toUpperCase() === "RAF-RDS" && (sessioneUtente?.ruolo?.toUpperCase() !== row.ruolo.toUpperCase() || row.ente && !row.ente.toUpperCase().includes(sessioneUtente?.sportello?.descrizione?.toUpperCase())))){
                            colElement = <></>
                        }else if(col.check === "checkUtente" && (sessioneUtente?.ruolo?.toUpperCase() === "RAF-RULSS" && ["RAF-RDS","RAF-RULSS"].indexOf(row.ruolo.toUpperCase()) < 0)){
                            colElement = <></>
                        } else{
                            colElement =
                                (
                                    <Button
                                        id={col.key + i}
                                        typeButton={col.typeButton}
                                        className={col.className}
                                        style={col.style}
                                        text={col.text}
                                        onClick={() => col.onClick(row[col.key])}
                                        disabled={col.disabled}
                                    />
                                )
                        }
                        break;
                    }

                    case "telefono": {
                        colElement = (
                            <>
                            {row[col.key] && row[col.key].view ?
                                <span>{row[col.key].numero}</span> :
                        <Icon
                            id={col.key + i}
                            path={iconaTelefonoBianco}
                            alt={"telefono"}
                            onClick={(event) => col.onClickTelefono(event)}
                            style={{cursor: "pointer"}}
                        />
                                }</>
                        )
                        break;
                    }
                    case "array": {
                        let arrayElement = "";
                        for (let i =0;i<row[col.key].length - 1;i++){
                            arrayElement = arrayElement.concat(row[col.key][i].descrizione).concat(" (").concat(province[row[col.key][i].codiceProvincia].descrizione).concat(")").concat(", ")
                        }
                        arrayElement = arrayElement.concat(row[col.key][row[col.key].length-1].descrizione).concat(" (").concat(province[row[col.key][row[col.key].length-1].codiceProvincia].descrizione).concat(")")

                        colElement = (
                            <span id={col.key + i} data-toggle="tooltip" data-placement="top"
                                  title={arrayElement}>{arrayElement}</span>
                        )
                        break;
                    }
                    case "decodingElement": {
                        colElement =
                            (<span id={col.key + i} data-toggle="tooltip" data-placement="top"
                                   title={col.elementForDecode && col.elementForDecode[row[col.key]] && col.elementForDecode[row[col.key]].descrizione?
                                       col.elementForDecode[row[col.key]].descrizione:""}>{
                                col.elementForDecode && col.elementForDecode[row[col.key]] && col.elementForDecode[row[col.key]].descrizione?
                                col.elementForDecode[row[col.key]].descrizione:""}</span>)
                        break;
                    }
                    case "map": {
                        colElement =
                            (<span id={col.key + i} data-toggle="tooltip" data-placement="top"
                                   title={col.mapContent[row[col.key]]}>
                                {col.mapContent[row[col.key]]}
                            </span>)
                        break;
                    }
                    case "cf": {
                        colElement =
                            (<span id={col.key + i} data-toggle="tooltip" data-placement="top"
                                   title={row[col.key].replace("TINIT-","")}>{row[col.key].replace("TINIT-","")}</span>)
                        break;
                    }
                    default: {
                        colElement =
                            (<span id={col.key + i} data-toggle="tooltip" data-placement="top"
                                   title={row[col.key]}>{row[col.key]}</span>)
                    }
                }
                let td = (
                    <td key={col.key} className={style.azTableCell.concat(' noselect ').concat(col.type != "button" && style.tooltipTable)}
                        style={{verticalAlign: "middle", maxWidth: "100px", textAlign: "center"}}>
                        {colElement}
                    </td>
                )
                newRow.push(td)
            })
            finalRows.push(
                <tr key={i}>
                    {newRow}
                </tr>)
        })
        setRows(finalRows)
    }

    return (
        <div className={"table-wrapper-scroll-y my-custom-scrollbar "}>
            <Spinner show={showSpinner}/>
            {createPageLengthSelect()}
            {props.allegati ?
                <Row>

                    <div className={"col-11" } >
                        <h4 style={{ textAlign: isPageWide ? "center" : "left"}}>{props.title}</h4>
                    </div>
                    <div className={"col-1"} style={{display: "flex", justifyContent: "right"}}>
                            <Button
                                id={"Button3"}
                                onClick={onClickButtonAntemprima}
                                typeButton={"White"}
                                disabled={props.rows.length === 0}
                                text={"Anteprima"}
                                style={{height: "35px", width: "150px", minWidth: "150px"}}
                                icon={iconAnteprima}
                            />
                            <Button
                                id={"Button4"}
                                onClick={onClickButtonSalvaCsv}
                                typeButton={"White"}
                                disabled={props.rows.length === 0}
                                text={"Salva CSV"}
                                style={{height: "35px", width: "150px", minWidth: "150px"}}
                                icon={iconSalvaCsv}
                            />
                    </div>
                </Row>

                : <h3 style={{textAlign: "center"}}>{props.title}</h3>
            }
            <div className={"table-responsive-md overflowPrint ".concat(style.scrollTable)}>
                <table className={"table table-md ".concat(style.azTable).concat(" ").concat(props.customStyleTable).concat(!props.customStyleTable ? " table-borderless" : "")} id={props.id}
                       style={{marginTop: "1rem"}}>
                    <thead className={style.azTableHeader}>
                    <tr>
                        {cols}
                    </tr>
                    </thead>
                    {!rows || (rows && rows.length === 0) ?
                        <></>
                        :
                        <tbody className={style.azTableBody}>
                            {rows}
                        </tbody>
                    }
                </table>
                {!rows || (rows && rows.length === 0) ?
                    <div style={{textAlign: "center"}}><span>Nessun risultato trovato</span></div> : <></> }
            </div>
        </div>
    )
}

export default Table
